import { render, staticRenderFns } from "./TopLevelDomainsTab.vue?vue&type=template&id=7907dea6&scoped=true"
import script from "./TopLevelDomainsTab.vue?vue&type=script&lang=js"
export * from "./TopLevelDomainsTab.vue?vue&type=script&lang=js"
import style0 from "./TopLevelDomainsTab.vue?vue&type=style&index=0&id=7907dea6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7907dea6",
  null
  
)

export default component.exports